import { AxiosError, AxiosResponse } from 'axios';
import { useCustomMutate, useCustomQuery } from '../../../../hooks/query';
import { DELETE_ATTACHED_FILE, GET_APPLICATION_FILES_CONFIG } from './keys';
import { deleteAttachedFile, getApplicationFilesConfig } from '../api-services/api';
import { GenericErrorResponse } from '../../..';
import { ApplicationFilesConfig } from '../model';
import { ApplicationType } from '../../../candidate/config/model';

/** to delete file from draft
 * */
export const useDeleteAppealArrangementFile = (
  successCallback?: (res: any) => void,
  failCallback?: (res: any) => void
) =>
  useCustomMutate<AxiosResponse<{}>, string, AxiosError<GenericErrorResponse>>(
    DELETE_ATTACHED_FILE,
    deleteAttachedFile,
    {
      onSuccess: successCallback,
      onError: failCallback,
    },
    false,
    false
  );

export const useGetApplicationFilesConfig = (applicationType: ApplicationType) =>
  useCustomQuery<ApplicationFilesConfig>(GET_APPLICATION_FILES_CONFIG, () =>
    getApplicationFilesConfig(applicationType).then((response) => response.data)
  );
